import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationService } from '@/services/notification.service';
import { subscriptionService } from '@/services/subscription.service';

const useCancelSubscription = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ userId }: { userId: number }) =>
			await subscriptionService.cancelSubscription(userId),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['user'] });
			notificationService.success('Subscription cancelled');
		},
		onError: () => {
			notificationService.error('Error updating subscription');
		},
	});
};

export default useCancelSubscription;
